import { Phone, Star, Users } from "lucide-react";
import { MEDIA, CONTACT } from "../../lib/content";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 grain-overlay">
        <img src={MEDIA.hero} alt="Majestic tree at sunset" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-black/50" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-32 pb-20 w-full">
        <div className="max-w-3xl animate-fade-up">
          <div className="inline-flex items-center gap-2 mb-5 px-4 py-1.5 rounded-full border border-gold/30 bg-gold/5">
            <Users size={14} className="text-gold" />
            <span className="text-xs uppercase tracking-widest text-gold" data-testid="hero-family-owned">Family Owned &amp; Operated · Everett, WA</span>
          </div>
          <div className="flex items-center gap-2 mb-6">
            <div className="flex text-gold">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} fill="currentColor" />
              ))}
            </div>
            <span className="text-sm text-gray-300 tracking-wide">Trusted by local property owners</span>
          </div>

          <p className="font-cursive text-gold text-3xl md:text-4xl mb-2">Professional Tree Care</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-7xl font-bold leading-[1.05] text-white">
            You Can <span className="gold-text-gradient">Trust</span>.
          </h1>
          <p className="mt-6 text-base md:text-lg text-gray-300 max-w-xl leading-relaxed">
            Expert tree removal, pruning, stump grinding, and 24/7 storm response — delivered with
            precision and pride across Everett and the surrounding areas. Trees. Property. Pride.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#estimate"
              data-testid="hero-cta-button"
              className="bg-gold text-black font-bold px-8 py-4 rounded-sm hover:bg-gold-light transition-colors uppercase tracking-widest text-sm text-center"
            >
              Get Your Free Estimate
            </a>
            <a
              href={`tel:${CONTACT.ownerPhone}`}
              data-testid="hero-call-button"
              className="flex items-center justify-center gap-2 border border-gold text-gold px-8 py-4 rounded-sm hover:bg-gold/10 transition-colors uppercase tracking-widest text-sm"
            >
              <Phone size={16} /> Call {CONTACT.ownerPhone}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#0A0A0A] to-transparent z-[5]" />
    </section>
  );
};
